import { useEffect, useState } from "react"
import { Button, Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap"
import Template from "../../layout/Template"
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { ClienteService } from "../../services/api/Clientes/ClienteService"
import AnimaisClientes from "../Animais/AnimaisClientes"
import { useNavigate, useParams } from "react-router-dom"
import { limpaCpf, limpaTelefone } from "../../utils/Funcoes"
import { Commons } from "../../utils/Commons"
import { useHookFormMask } from 'use-mask-input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../components/Loader/Loading"
import { usePermissoes } from "../../hooks/usePermissoes"
import PermissoesComponent from "../../components/PermissaoComponent"
import ClienteMenuLateral from "./FichaCliente/ClienteMenuLateral"



const scheme = z.object({
    tiposPessoasId: z.string(),
    nome: z.string(),
    razaoSocial: z.string().nullable(),
    sobrenome: z.string().nullable(),
    cnpj: z.coerce.string().nullable(),
    cpf: z.coerce.string().nullable(),
    sexo: z.string().nullable(),
    email: z.union([
        z.literal(''),
        z.literal(null),
        z.string().email('E-mail inválido')
    ]),
    telefone: z.coerce.string().nullable(),
    celular: z.string().nullable().nullable(),
    cep: z.coerce.string().nullable(),
    logradouro: z.string().nullable(),
    numero: z.coerce.string().nullable(),
    complemento: z.string().nullable(),
    bairro: z.string().nullable(),
    cidade: z.string().nullable(),
    uf: z.string().nullable(),
    origemContatoId: z.coerce.string().nullable(),
    observacoes: z.string().nullable()



}).refine((data) => { return !(data.tiposPessoasId.toString() === '1' && data.nome == '') }, {
    message: "O Nome é obrigatório",
    path: ["nome"], // path of error
}).refine((data) => { return !(data.tiposPessoasId.toString() === '2' && data.razaoSocial == '') }, {
    message: "A Razão Social é obrigatória",
    path: ["razaoSocial"], // path of error
})

const ClienteCadEdit = ({  }) => {

    const navigate = useNavigate()
    const { idCliente } = useParams();
    const [cliente, setCliente] = useState(null)
    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: cliente
    })
    const registerWithMask = useHookFormMask(register);


    const [showAnimais, setShowAnimais] = useState(false)
    const [keyTab, setKeyTab] = useState('dadosPessoais')
    const [isPessoaJuridica, setIsPessoaJuridica] = useState(false)
    const watchShowJuridica = watch('tiposPessoasId')
    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)
        const { listPermissoes,isLoadingPerm } = usePermissoes([
            { secoesId: 3, acoesId: 1 },
            { secoesId: 3, acoesId: 2 },
        ])
        const [disabled, isDisabled] = useState(false)

    const onSubmit = async (data) => {
        setDisableSalvar(true)
        let DataForm = data
        DataForm.telefone = (DataForm.telefone != null) ? limpaTelefone(DataForm.telefone) : ''
        DataForm.celular = (DataForm.celular != null) ? limpaTelefone(DataForm.celular) : ''
        DataForm.cpf = (DataForm.cpf != null) ? limpaCpf(DataForm.cpf) : ''
        DataForm.cep = (DataForm.cep != null) ? limpaCpf(DataForm.cep) : ''
        DataForm.cnpj = (DataForm.cnpj != null) ? limpaCpf(DataForm.cnpj) : ''

        //console.log((DataForm))
        if (idCliente != undefined) {
            const res = await ClienteService.updateById(idCliente, DataForm)

            if (res.success) {
                navigate('/admin/clientes')
            } else {
                alert(res.msg)
                setDisableSalvar(false)
            }
        } else {
            const res = await ClienteService.store(DataForm)

            if (res.success) {
                navigate('/admin/clientes/'+res.data.id+'/animais')
            }
        }

    }

    // console.log((idCliente))

    useEffect(() => {

        if (idCliente != undefined) {
            const fetchData = async () => {
                setIsloading(true);
                const data = await ClienteService.getById(idCliente)
                const cli = data.data
                setCliente({
                    ...cli,
                    tiposPessoasId: (cli?.tipos_pessoas?.id) ? cli?.tipos_pessoas?.id.toString() : '',
                    uf: (cli?.ufs?.sigla) ? cli?.ufs?.sigla : ''
                })
                setIsloading(false);
            }
            fetchData()



            setShowAnimais(true)
        } else {
            setIsloading(false);
            setCliente({
                ...cliente,
                tiposPessoasId: '1'
            })
        }

    }, [])



    useEffect(() => {
        if (watchShowJuridica == 2) {
            setIsPessoaJuridica(true)
        } else {
            setIsPessoaJuridica(false)
        }

        //console.log(watchShowJuridica)
    }, [watchShowJuridica])


    console.log(showAnimais)
    return (
        <>
         <ClienteMenuLateral idCliente={cliente?.id}>
 <div className="box-fundo">
                <h3><span className="text-primary">Clientes </span> {(cliente?.nome != null) ? '- ' + cliente.nome : ''} {(cliente?.sobrenome != null) ? cliente.sobrenome : ''}</h3>
                <h4 className="text-primary"></h4>
                <hr></hr>


                <div style={{ maxWidth: '800px' }}>

                    {(isLoading) ? <Loading /> : (

                        <>
   {(
                                (!listPermissoes?.cadastrar && !isLoadingPerm && idCliente == null)
                                || (!listPermissoes?.editar && !isLoadingPerm && idCliente != null)
                            ) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                <>
                            <Tabs
                                activeKey={keyTab}
                                onSelect={(k) => setKeyTab(k)}
                                className="mb-3">

                                <Tab eventKey="dadosPessoais" title="Dados Pessoais" >
                                    <Form>
                                        <Row>
                                            <Form.Group >
                                                <Form.Label>Tipo de Pessoa:</Form.Label><br />
                                                <Form.Check
                                                    inline
                                                    type="radio"
                                                    label="Pessoa Física"
                                                    value="1"

                                                    {...register('tiposPessoasId')}
                                                ></Form.Check>
                                                <Form.Check
                                                    inline
                                                    type="radio"
                                                    label="Pessoa Jurídica"
                                                    value="2"
                                                    {...register('tiposPessoasId')}></Form.Check>
                                            </Form.Group>
                                        </Row>

                                        <div className="divPessoaJuridica" style={{ display: (isPessoaJuridica) ? '' : 'none' }}>
                                            <Row >
                                                <Form.Group as={Col} controlId="formRazaoSocial">
                                                    <Form.Label>Razão Social</Form.Label>
                                                    <Form.Control type="text" placeholder="Razão Social"
                                                        {...register('razaoSocial')}
                                                        isInvalid={!!(errors?.razaoSocial)}
                                                    ></Form.Control>
                                                </Form.Group>
                                                <Form.Control.Feedback type='invalid' >
                                                    {errors?.razaoSocial?.message}
                                                </Form.Control.Feedback>

                                            </Row>
                                            <Row >
                                                <Form.Group as={Col} controlId="formNomeFantasia" xs={8}>
                                                    <Form.Label>Nome Fantasia</Form.Label>
                                                    <Form.Control type="text" placeholder="Nome Fantasia"
                                                        isInvalid={false}
                                                        {...register('nomeFantasia')}
                                                    ></Form.Control>
                                                    <Form.Control.Feedback type="invalid">

                                                    </Form.Control.Feedback>

                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formCnpj" xs={4} >
                                                    <Form.Label>CNPJ:</Form.Label>
                                                    <Form.Control type="text" placeholder="CNPJ"
                                                        {...registerWithMask('cnpj', ['99.999.999/9999-99'])}
                                                    ></Form.Control>
                                                </Form.Group>
                                            </Row>


                                        </div>

                                        <div className="divPessoaFisica" style={{ display: (!isPessoaJuridica) ? '' : 'none' }}>

                                            <Row className="lg-5" >
                                                <Form.Group as={Col} controlId="formNome" xs={6}>
                                                    <Form.Label>Nome*</Form.Label>
                                                    <Form.Control type="text" placeholder="Nome"
                                                        {...register('nome')}
                                                        isInvalid={!!errors?.nome}
                                                    />
                                                    <Form.Control.Feedback type='invalid'>
                                                        {errors?.nome?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formSobrenome" xs={6}>
                                                    <Form.Label>Sobrenome</Form.Label>
                                                    <Form.Control type="text" placeholder="Sobrenome"
                                                        {...register('sobrenome')}
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row >
                                                <Form.Group as={Col} md={4} controlId="formCpf">
                                                    <Form.Label>CPF:</Form.Label>
                                                    <Form.Control type="text" placeholder="CPF"
                                                        {...registerWithMask('cpf', ['999.999.999-99'])} />
                                                </Form.Group>
                                                <Form.Group as={Col} md={4} controlId="formSexo">
                                                    <Form.Label>Sexo:</Form.Label>
                                                    <Form.Select placeholder="Sexo"
                                                        {...register('sexo')}>
                                                        <option value=''>Selecione...</option>
                                                        <option value='M'>Masculino</option>
                                                        <option value='F'>Feminino</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Row>
                                        </div>
                                        <Row>
                                            <Form.Group as={Col} controlId="formEmail" xs={12} md={4}>
                                                <Form.Label>E-mail</Form.Label>
                                                <Form.Control type="text" placeholder="E-mail" isInvalid={!!errors?.email}
                                                    {...register('email')} />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.email?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formTelefone" className="align-self-start">
                                                <Form.Label>Telefone</Form.Label>
                                                <Form.Control type="text" placeholder="Telefone"

                                                    {...registerWithMask('telefone', ['(99) 9999-9999'])}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formCelular">
                                                <Form.Label>Celular</Form.Label>
                                                <Form.Control type="text" placeholder="Celular"
                                                    {...registerWithMask('celular', ['(99) 99999-9999'])}
                                                ></Form.Control>
                                            </Form.Group>
                                        </Row>
                                        <hr></hr>
                                        <Row>
                                            <Form.Group as={Col} md={4} controlId="formCep">
                                                <Form.Label>CEP</Form.Label>
                                                <Form.Control type="text" placeholder="CEP"
                                                    {...registerWithMask('cep', ['99999-999'])}></Form.Control>
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            <Form.Group as={Col} controlId="formLogradouro">
                                                <Form.Label>Logradouro</Form.Label>
                                                <Form.Control type="text" placeholder="Logradouro"
                                                    {...register('logradouro')} />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formLNumero" md={2}>
                                                <Form.Label>Número</Form.Label>
                                                <Form.Control type="text" placeholder="Numero"
                                                    {...register('numero')}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formComplemento">
                                                <Form.Label>Complemento</Form.Label>
                                                <Form.Control type="text" placeholder="Complemento"
                                                    {...register('complemento')} />
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            <Form.Group as={Col} controlId="formBairro">
                                                <Form.Label>Bairro</Form.Label>
                                                <Form.Control type="text" placeholder="Bairro"
                                                    {...register('bairro')}></Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formCidade">
                                                <Form.Label>Cidade</Form.Label>
                                                <Form.Control type="text" placeholder="Cidade"
                                                    {...register('cidade')}></Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formUf">
                                                <Form.Label>UF</Form.Label>
                                                <Form.Select type="text" placeholder="UF"
                                                    {...register('uf')} >
                                                    <option value=''>Selecione...</option>
                                                    {Commons.getOptionsUF().map((item, key) => (
                                                        <option value={item.sigla} key={key}>{item.sigla} - {item.nome} </option>

                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <hr></hr>
                                        {/*
                                        <Row>

                                            <Form.Group as={Col} md={4} controlId="formOrigrmContato">
                                                <Form.Label>Origem do contato:</Form.Label>
                                                <Form.Select placeholder="Origem do contato"
                                                    {...register('origem_contato')}>
                                                    <option value=''>Selecione...</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>*/}
                                        <Row>
                                            <Form.Group as={Col} md={12} controlId="formObservacao">
                                                <Form.Label>Observações</Form.Label>
                                                <Form.Control as="textarea" rows={4} placeholder="Observações"
                                                    {...register('observacoes')}></Form.Control>
                                            </Form.Group>

                                        </Row>
                                        {/*  <Row>
                                        <Form.Group as={Col} controlId="formAlerta">
                                            <Form.Label>Alerta</Form.Label>
                                            <Form.Control as="textarea" placeholder="Alerta"
                                                {...register('alerta')}></Form.Control>
                                        </Form.Group>
                                    </Row>*/}
                                    <br></br>
                                        <div className="text-center ">
                                            <Button variant="success" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                                {(disableSalvar) ? <>
                                                    <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                                </> : 'Salvar'}</Button>

                                                   <Button variant="success" className="ml-15" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                                {(disableSalvar) ? <>
                                                    <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                                </> : 'Salvar/Cadastrar animais'}</Button>
                                        </div>

                                    </Form>
                                </Tab>

                                {/* 
                                <Tab eventKey='animais' title="Animais" tabClassName={!showAnimais ? 'd-none' : ''}>
                                    <AnimaisClientes />
                                </Tab>*/}
                            </Tabs>
                        </>)}
                         </>)}
                </div>
                </div>
                </ClienteMenuLateral>

        </>
    )
}
export default ClienteCadEdit;